/**
 * OIDC Configuration using vue3-oidc
 * Configures the OIDC client for authentication with Keycloak or Microsoft Entra.
 * See: https://github.com/nicepkg/vue3-oidc
 */
import { createOidc, useOidcStore } from 'vue3-oidc'

// Initialize OIDC - call this in main.ts before app.mount()
export async function initOidc() {
  await createOidc({
    oidcSettings: {
      authority: import.meta.env.VITE_OIDC_AUTHORITY || '',
      client_id: import.meta.env.VITE_OIDC_CLIENT_ID || '',
      redirect_uri: `${window.location.origin}/callback`,
      post_logout_redirect_uri: `${window.location.origin}/`,
      scope: import.meta.env.VITE_OIDC_API_SCOPE
        ? `openid profile email ${import.meta.env.VITE_OIDC_API_SCOPE}`
        : 'openid profile email',
      response_type: 'code',
      automaticSilentRenew: true,
      loadUserInfo: false,
    },
  })

  // createOidc internally calls getUser().then(setUser) but doesn't await it,
  // so the user may not be set before the router guard fires.
  // Explicitly await getUser() and use actions.setUser() to update reactive state.
  const { state, actions } = useOidcStore()
  const user = await state.value?.userManager?.getUser()
  if (user) {
    actions.value.setUser(user)
  }
}